module.exports = __webpack_public_path__ + "static/img/logo.39bf37ab.png";